export default defineNuxtRouteMiddleware((to) => {
  const regularId = to.params.regularId;
  const isValid: boolean =
    typeof regularId === 'string' && // 1. パスパラメータが文字列であること
    /^[0-9]+$/.test(regularId) && // 2. 0以上の整数（数字のみ）で構成されていること
    Number.isFinite(Number(regularId)) && // 3. 数値変換して有限な値であること（NaNやInfinityを除外）
    Number(regularId) > 0; // 4. 0より大きい（正の整数）であること

  if (!isValid) {
    return navigateTo('/mypage/regular-info');
  }
});
